.wrap {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid var(--border-primary);
}

.table thead th {
  padding: 12px 12px 12px 0;
  text-align: left;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border-primary);
  white-space: nowrap;
}

.table td,
.table tbody th {
  padding: 14px 12px 14px 0;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid var(--border-subtle);
}

.table tbody tr:hover {
  background: var(--bg-secondary);
}

.mono {
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  color: var(--text-muted);
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
